import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { RecurringBroadcastsPage } from 'pages/broadcasts/pages/broadcasts/recurring/ui/RecurringBroadcastsPage'

export const RecurringRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route path={'/'} element={<RecurringBroadcastsPage />} />
    </RoutesWithNotFound>
  )
}
